/**
 * @file Countdown
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Countdown component
 */
const vCountdown = () => {
	const countdown = document.querySelector( '.v-countdown' );

	if ( ! countdown ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const background  = countdown.querySelector( '.v-countdown__background' );
	const defaults    = { ease: 'power1.inOut' };
	const triggerVars = {
		trigger: countdown,
		scrub:   .5,
	};
	const bgFrom      = { scaleX: .1 };
	const bgTo        = { scaleX: 1 };

	ScrollTrigger.matchMedia( {
		'(min-width: 1650px)': () => {
			gsap.timeline( {
				scrollTrigger: {
					start: 'top bottom',
					end:   'bottom-=228 center',
					...triggerVars,
				},
				defaults,
			} )
				.fromTo( background, bgFrom, bgTo );
		},
		'(min-width: 1024px) and (max-width: 1649px)': () => {
			gsap.timeline( {
				scrollTrigger: {
					start: 'top bottom',
					end:   'bottom-=189 center',
					...triggerVars,
				},
				defaults,
			} )
				.fromTo( background, bgFrom, bgTo );
		},
		'(max-width: 1023px)': () => {
			gsap.timeline( {
				scrollTrigger: {
					start: 'top bottom',
					end:   'center center',
					...triggerVars,
				},
				defaults,
			} )
				.fromTo( background, bgFrom, bgTo );
		},
	} );
};

export default vCountdown;
